import { FGHeader, FGHeaderLogo, IconsLarge, FGIcons, FGButton } from '@fg/design-system';
import { UserProfile } from './UserProfile';
import { HeaderLogo } from './HeaderLogo';
import { getLogoUrl } from '../services/logoHelper';

type Props = {
  logoType: string;
  fullName?: string;
  appCode?: string;
};
export const Header = ({ logoType, fullName, appCode }: Props) => {
  const currentLocation = window.location.host;
  let isFrp = logoType === 'pro';
  let hideHelp = false;
  let showUserProfile;
  let logoTypeVal;
  let showFRRDLogo = true;
  logoTypeVal = 'group';
  if (logoType) {
    logoTypeVal = logoType;
  }
  if (window.location.toString().indexOf('/help') !== -1) {
    hideHelp = true;
  }

  if (window.location.toString().indexOf('/launchpad') !== -1) {
    showUserProfile = true;
  }

  if (window.location.toString().indexOf('/termsofuse') !== -1) {
    showFRRDLogo = false;
  }

  const isCdnImage = logoType === '' || logoType === 'solutions' || logoType === 'sustainable' || logoType === 'admin' || logoType == 'credit-sights' || logoType == 'geoquant' || isFrp;

  const openInquiries = () => {
    const helpPageUrl = appCode
      ? `${window.location.origin}/help?appCode=${appCode}`
      : `${window.location.origin}/help`;
    window.open(helpPageUrl);
  };
  return (
    <div style={{ padding: '0 8px 8px 8px' }}>
      <FGHeader
        left={
          isCdnImage ? (
            <HeaderLogo logoType={logoType} />
          ) : (
            <div>
              <FGHeaderLogo name={logoTypeVal} />
            </div>
          )
        }
        center={
          isFrp &&
          showFRRDLogo && (
            <div className="fg-header__item--hide-mobile">
              <div className="fg-d--f" style={{ justifyContent: 'center' }}>
                <img src={getLogoUrl('App_brandmarks_FRRD.png', currentLocation)} alt="Header Logo" height="50" />
              </div>
            </div>
          )
        }
        right={
          <>
            {!hideHelp && (
              <FGButton variant="ghost" className="pi-help-button" aria-label="Support" onClick={openInquiries}>
                <FGIcons className="pi-help-button" large={IconsLarge.Help} />
              </FGButton>
            )}
            {showUserProfile && <UserProfile fullName={fullName} />}
          </>
        }
      />
    </div>
  );
};
